(function () {
  var root = document.documentElement;
  root.classList.add('sk-js');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal() {
    var els = document.querySelectorAll('[data-reveal]');
    if (!('IntersectionObserver' in window) || reduce) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  }

  // Drifting gold dust, like incense smoke catching light
  function initDust(canvas) {
    var ctx = canvas.getContext('2d');
    var parts = [];
    var w = 0, h = 0, raf = 0, visible = true;
    var dpr = Math.min(window.devicePixelRatio || 1, 2);

    function resize() {
      var r = canvas.getBoundingClientRect();
      w = r.width; h = r.height;
      canvas.width = w * dpr; canvas.height = h * dpr;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      var n = Math.round(Math.min(90, Math.max(30, (w * h) / 16000)));
      parts = [];
      for (var i = 0; i < n; i++) parts.push(make(true));
    }
    function make(initial) {
      return {
        x: Math.random() * w,
        y: initial ? Math.random() * h : h + 10,
        r: Math.random() * 1.8 + 0.4,
        vy: -(Math.random() * 0.25 + 0.05),
        vx: (Math.random() - 0.5) * 0.12,
        a: Math.random() * 0.5 + 0.15,
        p: Math.random() * Math.PI * 2
      };
    }
    function draw() {
      ctx.clearRect(0, 0, w, h);
      for (var i = 0; i < parts.length; i++) {
        var p = parts[i];
        p.p += 0.01;
        p.x += p.vx + Math.sin(p.p) * 0.12;
        p.y += p.vy;
        if (p.y < -10 || p.x < -10 || p.x > w + 10) parts[i] = make(false);
        var tw = 0.6 + 0.4 * Math.sin(p.p * 2);
        ctx.beginPath();
        ctx.fillStyle = 'rgba(227,194,122,' + (p.a * tw).toFixed(3) + ')';
        ctx.arc(p.x, p.y, p.r, 0, 6.2832);
        ctx.fill();
      }
      if (visible && !reduce) raf = requestAnimationFrame(draw);
    }
    resize();
    draw();
    if (reduce) return;
    window.addEventListener('resize', resize);
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (en) {
        visible = en[0].isIntersecting;
        cancelAnimationFrame(raf);
        if (visible) draw();
      }).observe(canvas);
    }
  }

  // Header gets a hairline border and soft shadow once the page is scrolled
  function initHeaderScroll() {
    if (window.__skScrollBound) return;
    window.__skScrollBound = true;
    var ticking = false;
    function offset(t) {
      if (t && t !== document && t !== root && typeof t.scrollTop === 'number') return t.scrollTop;
      return window.scrollY || root.scrollTop || 0;
    }
    var last = 0;
    function update() {
      root.classList.toggle('sk-scrolled', last > 8);
      ticking = false;
    }
    // Capture phase: the page may scroll inside a wrapper element, not the window
    document.addEventListener('scroll', function (e) {
      last = offset(e.target);
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }, { passive: true, capture: true });
  }

  function init() {
    initHeaderScroll();
    initReveal();
    document.querySelectorAll('canvas[data-sk-dust]').forEach(initDust);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
